<template>
  <div class="card">
    <div class="card-body">
      <div class="card-title">
        <h2>
          공지사항 작성
        </h2>
        <p class="gray">공지사항을 작성합니다.</p>
      </div>
    </div>

    <el-form :model="frm" :rules="rules" status-icon ref="frm" label-width="120px" class="demo-form">
      <div class="card-body gray">
        <div class="card-form textarea">
          <el-form-item label="제목" prop="title">
            <el-input v-model="frm.title" placeholder="제목을 입력하십시오."></el-input>
          </el-form-item>

          <el-form-item label="내용" prop="content">
            <!-- <el-input type="textarea" :rows="5" v-model="frm.content" placeholder="내용을 입력하십시오."></el-input> -->
            <stone-tui-editor ref="editor" :options="options" />
            <!-- <stone-tui-viewer ref="viewer" :content="frm.content" /> -->
          </el-form-item>
        </div>
        <div class="card-form">
          <!-- <el-form-item label="이미지" prop="">
            <el-upload
              class="upload-demo"
              drag
              action="/api/file/upload"
              :headers="imageHeaders"
              :on-preview="commonUploadFilePreview"
              :on-remove="commonUploadFileRemove"
              :on-success="handleUploadSuccess"
              :before-upload="handleBeforeUpload"
              :before-remove="commonBeforeUploadFileRemove"
              :file-list="imageList"
              list-type="picture"
              multiple
              :limit="2">
              <div class="el-upload__text">
                업로드 하려는 파일을 끌어다 놓으세요.<br />
                <button class="btn plus-btn white"><i class="fas fa-plus"></i></button>
              </div>
            </el-upload>
          </el-form-item> -->

          <el-form-item label="첨부파일" prop="">
            <el-upload
              class="upload-demo"
              drag
              action="/api/file/upload"
              :headers="fileHeaders"
              :on-preview="commonUploadFilePreview"
              :on-remove="commonUploadFileRemove"
              :before-remove="commonBeforeUploadFileRemove"
              :on-success="handleUploadSuccess"
              :file-list="fileList"
              list-type="text"
              multiple
              :limit="5">
              <div class="el-upload__text">
                업로드 하려는 파일을 끌어다 놓으세요.<br />
                <button class="btn plus-btn white"><i class="fas fa-plus"></i></button>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">files with a size less than 2MB</div> -->
            </el-upload>
          </el-form-item>

          <el-form-item label="공지대상" prop="class">
            <el-select v-model="frm.class" multiple placeholder="선택하세요." style="width: 100%;" @change="changeClass">
              <el-option v-for="item in classData" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="공개기간" class="datepicker">
            <el-date-picker
              v-model="noticeDate"
              type="daterange"
              range-separator="~"
              value-format="yyyyMMdd"
              start-placeholder="시작일"
              end-placeholder="종료일">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="공개여부">
            <el-switch v-model="isUse" active-text="" inactive-text=""></el-switch>
          </el-form-item>
        </div>
      </div>
      <div class="card-body text-right">
        <el-button type="default" @click="resetForm('frm')">취소</el-button>
        <!-- <el-button type="warning" v-if="frm.board_seq !== 0" @click="dialogFormVisible = true">알림톡 보내기</el-button> -->
        <el-button type="danger" v-if="frm.board_seq !== 0" @click="deleteBoard">삭제</el-button>
        <el-button type="primary" @click="submitForm('frm')">저장</el-button>
      </div>

    </el-form>

    <el-dialog title="알림톡 전송" :visible.sync="dialogFormVisible" width="500px">
      <el-form ref="frmKakao" :model="frmKakao" :rules="rulesKakao" label-width="120px">
        <el-form-item label="전송 대상" prop="checkList">
          <el-checkbox-group v-model="frmKakao.checkList" :min="1">
            <el-checkbox label="S">학생</el-checkbox>
            <el-checkbox label="P">학부모</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelKakao">취소</el-button>
        <el-button type="primary" @click="sendKakao">전송</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import common from '@/modules/common'
import StoneTuiEditor from '@/components/stone-tui-editor'
// import StoneTuiViewer from '@/components/stone-tui-viewer'

export default {
  name: 'M990602',
  mixins: [common.mixins],
  components: {StoneTuiEditor},
  data () {
    return {
      isUse: true,
      isModify: false,
      frm: {
        board_seq: 0,
        board_type: 'NOTICE',
        title: '',
        content: '',
        start_dt: '',
        end_dt: '',
        open_yn: 'Y',
        board_class: [],
        class: [],
        file_list: []
      },
      imageHeaders: {},
      imageList: [],
      fileHeaders: {
        Authorization: '',
        Seq: 0,
        Table: 'BOARD'
      },
      fileList: [],
      classData: [{
        value: 0,
        label: '전체'
      }],
      noticeDate: [],
      rules: {
        title: [
          { required: true, message: '제목을 입력하십시오.', trigger: 'blur' },
          { min: 3, max: 100, message: '최소 3자 이상 최대 100자까지 입력하십시오.' }
        ],
        content: [
          { required: true, message: '내용을 입력하십시오.', trigger: 'blur' },
          { min: 10, message: '최소 10자 이상 입력하십시오.' }
        ],
        class: [
          { required: true, message: '공지대상을 선택하십시오.', trigger: 'change' }
        ]
      },
      options: {},
      dialogFormVisible: false,
      frmKakao: {
        checkList: ['S']
      },
      rulesKakao: {
        checkList: [
          { required: true, message: '전송 대상을 선택하십시오.', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    common.axios.post('/class/list')
      .then(response => {
        const result = response.data
        result.forEach(c => {
          this.classData.push({label: c.class_name, value: c.class_seq, disabled: c.use_yn === 'N'})
        })
        const boardSeq = this.$route.params.board_seq
        if (!this.isEmptySeq(boardSeq)) {
          this.isModify = true
          this.loadInfo(boardSeq)
        }
      })
  },
  mounted () {
    this.fileHeaders.Authorization = this.$store.getters.access_token
    this.imageHeaders = Object.assign({type: 'IMAGE'}, this.fileHeaders)
  },
  methods: {
    handleEditorChange () {
      this.frm.content = this.$refs.editor.editor.getHtml()
    },
    setEditorContent (value) {
      this.$refs.editor.editor.setHtml(value)
    },
    getEditorContent () {
      return this.$refs.editor.editor.getHtml()
    },
    submitForm (formName) {
      this.frm.content = this.getEditorContent()
      this.$refs[formName].validate(valid => {
        if (valid) {
          const boardClass = []
          this.frm.class.forEach(x => {
            boardClass.push({class_seq: x})
          })
          this.frm.board_class = boardClass
          const config = {
            url: this.isModify ? '/board' : '/board/storage',
            method: this.isModify ? 'put' : 'post',
            data: this.frm
          }
          common.axios.request(config)
            .then(response => {
              if (response.data.status === 1) {
                if (this.isModify) {
                  this.$message('수정하였습니다.')
                } else {
                  this.$message('등록하였습니다.')
                }
                setTimeout(() => {
                  this.$router.push({name: 'M990601'})
                }, 1000)
              }
            })
        } else {
          this.$message.error('등록 내용을 확인하십시오.')
          return false
        }
      })
    },
    resetForm (formName) {
      // this.$refs[formName].resetFields()
      // this.clearForm()
      this.$router.push({name: 'M990601'})
    },
    handleUploadSuccess (res, file) {
      this.frm.file_list.push(res)
    },
    handleBeforeUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('이미지 파일(JPG/PNG)만 업로드 가능합니다.')
      }
      if (!isLt2M) {
        this.$message.error('이미지 파일 크기는 2MB를 넘을 수 없습니다.')
      }
      return isJPG && isLt2M
    },
    clearForm () {
      this.frm.board_seq = 0
      this.noticeDate = []
      this.frm.class = []
      this.frm.board_class = []
      this.fileList = []
      this.isUse = true
    },
    loadInfo (boardSeq) {
      common.axios.get('/board/load/' + boardSeq)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          Object.keys(this.frm).forEach(key => {
            this.frm[key] = this.isEmpty(result.board[key]) ? '' : result.board[key]
          })
          this.setEditorContent(result.board.content)
          const boardClass = []
          result.board_class.map(x => {
            boardClass.push(x.class_seq)
          })
          this.frm.class = boardClass
          this.frm.file_list = []
          if (result.board.start_dt && result.board.end_dt) {
            this.noticeDate = [result.board.start_dt, result.board.end_dt]
          }
          this.isUse = result.board.open_yn === 'Y'
          result.fileList.map(f => {
            if (f.file_type === 'IMAGE') {
              this.imageList.push(f)
            } else {
              this.fileList.push(f)
            }
          })
          // this.fileList = result.fileList
        })
    },
    changeClass (value) {
      if (value.filter(x => x === 0).length > 0) {
        this.frm.class = [0]
      }
    },
    deleteBoard () {
      this.$confirm('공지사항을 삭제하시겠습니까?', '', {
      }).then(() => {
        common.axios.delete('/board', {data: {board_seq: this.frm.board_seq}})
          .then(response => {
            this.$message('삭제되었습니다.')
            setTimeout(() => {
              this.$router.push({name: 'M990601'})
            }, 1000)
          })
          .catch(() => {
            this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {
      })
    },
    sendKakao () {
      this.$refs.frmKakao.validate(valid => {
        const param = {
          board_seq: this.frm.board_seq,
          user_type: this.frmKakao.checkList
        }
        // console.log('param : ', param)
        common.axios.post('/board/notice/kakao', param)
          .then(response => {
            const result = response.data
            if (result.status === 1) {
              this.$message('알림톡을 발송하였습니다.')
              this.cancelKakao()
            } else {
              this.$message.warning(result.message)
            }
          })
      })
    },
    cancelKakao () {
      this.dialogFormVisible = false
      this.frmKakao.checkList = ['S']
    }
  },
  watch: {
    isUse: function (value) {
      this.frm.open_yn = value ? 'Y' : 'N'
    },
    noticeClass: function (value) {
    },
    noticeDate: function (value) {
      if (value && value.length === 2) {
        this.frm.start_dt = value[0]
        this.frm.end_dt = value[1]
      } else {
        this.frm.start_dt = ''
        this.frm.end_dt = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
  }
  .avatar-uploader:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-dialog label {
    width: 100px;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M990602.vue